"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rignano-sull-arno": {
    "ba8dc5af": [{
      "hkey": "64850509",
      "slug": "rignano-sull-arno",
      "name": "Rignano sull'Arno",
      "primary": true,
      "skipSearch": false
    }],
    "castellonchio": [{
      "hkey": "64850509",
      "slug": "rignano-sull-arno",
      "name": "Rignano sull'Arno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;